import { FormGroup, FormSection, TextInput } from '@ksyos/design-system';
import type { IService } from '@common/interfaces/';
import type { ValidationErrors } from '@frontend/utils/';
import { translateKey } from '@frontend/translate';
import { getValidationErrorTranslation } from '@frontend/utils/';
import { SettingsSwitch } from '../../modals/components/SettingsSwitch';

export interface IZorgMail {
    receiveZorgmailOnConsultOpen: boolean;
    zorgmailNummer: string | null;
}

export interface IZorgMailProps {
    errorPrefix?: string;
    errors?: ValidationErrors;
    onChange: (key: keyof IZorgMail, value: IZorgMail[keyof IZorgMail]) => void;
    onDoValidate?: (key: keyof IZorgMail) => void;
    service: IService;
    zorgMail: IZorgMail;
}

export function ZorgMail(props: IZorgMailProps) {
    return (
        <FormSection title={translateKey('serviceOrganizationSetting.zorgMail')}>
            <FormGroup
                hasErrors={hasError('receiveZorgmailOnConsultOpen')}
                label={translateKey('serviceOrganizationSetting.receiveZorgmailOnConsultOpen')}
            >
                <SettingsSwitch
                    error={getErrorMessage('receiveZorgmailOnConsultOpen')}
                    listKey={`receiveZorgmailOnConsultOpen-${props.service.id}`}
                    onBlur={() => handleValidateOne('receiveZorgmailOnConsultOpen')}
                    onChange={(value) => props.onChange('receiveZorgmailOnConsultOpen', value)}
                    value={props.zorgMail.receiveZorgmailOnConsultOpen}
                />
            </FormGroup>
            {props.zorgMail.receiveZorgmailOnConsultOpen && (
                <FormGroup
                    hasErrors={hasError('zorgmailNummer')}
                    label={translateKey('serviceOrganizationSetting.zorgMail')}
                >
                    <TextInput
                        error={getErrorMessage('zorgmailNummer')}
                        maxLength={9}
                        onBlur={() => handleValidateOne('zorgmailNummer')}
                        onChange={(e) => props.onChange('zorgmailNummer', e.target.value ?? null)}
                        placeholder={translateKey('employment.zorgmailNummer')}
                        value={props.zorgMail.zorgmailNummer ?? ''}
                    />
                </FormGroup>
            )}
        </FormSection>
    );

    function hasError(key: keyof IZorgMail) {
        const errorKey = getErrorKey(key);

        return props.errors?.has(errorKey);
    }

    function getErrorMessage(key: keyof IZorgMail) {
        const errorKey = getErrorKey(key);

        return getValidationErrorTranslation(props.errors?.get(errorKey));
    }

    function getErrorKey(key: keyof IZorgMail) {
        return `${props.errorPrefix ?? ''}${key}`;
    }

    function handleValidateOne(key: keyof IZorgMail) {
        if (props.onDoValidate) {
            props.onDoValidate(key);
        }
    }
}
